/** Query parameter that deep-links a grid to a view preset (`?viewPreset=<uuid>`). */
export const VIEW_PRESET_QUERY_PARAM = 'viewPreset';
